module.exports = __webpack_public_path__ + "img/1500972200.658efc9f.jpg";